import NetworkApi from "../../data/network/NetworkApi";
import NetworkApiImpl from "../../data/network/NetworkApiImpl";
import { AdminRepository } from "../../data/repository/admin/AdminRepository";
import { AdminRepositoryImpl } from "../../data/repository/admin/AdminRepositoryImpl";
import { AnswerRepository } from "../../data/repository/answer/AnswerRepository";
import { AnswerRepositoryImpl } from "../../data/repository/answer/AnswerRepositoryImpl";
import { AuthRepository } from "../../data/repository/auth/AuthRepository";
import { AuthRepositoryImpl } from "../../data/repository/auth/AuthRepositoryImpl";
import { CategoryRepository } from "../../data/repository/category/CategoryRepository";
import { CategoryRepositoryImpl } from "../../data/repository/category/CategoryRepositoryImpl";
import { QuestionRepository } from "../../data/repository/question/QuestionRepository";
import { QuestionRepositoryImpl } from "../../data/repository/question/QuestionRepositoryImpl";
import { StatsRepository } from "../../data/repository/stats/StatsRepository";
import { StatsRepositoryImpl } from "../../data/repository/stats/StatsRepositoryImpl";
import { UploadFileRepository } from "../../data/repository/uploadFIle/UploadFileRepository";
import { UploadFileRepositoryImpl } from "../../data/repository/uploadFIle/UploadFileRepositoryImpl";
import {
  GetAdminInfoUseCase,
  GetAdminInfoUseCaseImpl,
} from "../../domain/usecase/admin/getInfo/UseCase";
import {
  UpdateAdminInfoUseCase,
  UpdateAdminInfoUseCaseImpl,
} from "../../domain/usecase/admin/updateInfo/UseCase";
import {
  CreateAnswerUseCase,
  CreateAnswerUseCaseImpl,
} from "../../domain/usecase/answer/create/CreateUseCase";
import {
  DeleteAnswerUseCase,
  DeleteAnswerUseCaseImpl,
} from "../../domain/usecase/answer/delete/DeleteUseCase";
import {
  DeleteAnswerAttachmentUseCase,
  DeleteAnswerAttachmentUseCaseImpl,
} from "../../domain/usecase/answer/deleteAttachment/UseCase";
import {
  DeleteAnswerByQuestionIdUseCase,
  DeleteAnswerByQuestionIdUseCaseImpl,
} from "../../domain/usecase/answer/deleteByQuestionId/DeleteByQuestionIdUseCase";
import {
  GetAnswerUseCase,
  GetAnswerUseCaseImpl,
} from "../../domain/usecase/answer/get/GetUseCase";
import {
  GetAllAnswersUseCase,
  GetAllAnswersUseCaseImpl,
} from "../../domain/usecase/answer/getAll/GetAllUseCase";
import {
  GetAnswersByListOfQuestionsIdUseCase,
  GetAnswersByListOfQuestionsIdUseCaseImpl,
} from "../../domain/usecase/answer/getAllByListOfQuestionsId /UseCase";
import {
  GetAnswerByQuestionIdUseCase,
  GetAnswerByQuestionIdUseCaseImpl,
} from "../../domain/usecase/answer/getByQuestionId/GetByQuestionIdUseCase";
import {
  UpdateAnswerUseCase,
  UpdateAnswerUseCaseImpl,
} from "../../domain/usecase/answer/update/UpdateUseCase";
import {
  LoginUseCase,
  LoginUseCaseImpl,
} from "../../domain/usecase/auth/Login/LoginUseCase";
import {
  CreateCategoryUseCase,
  CreateCategoryUseCaseImpl,
} from "../../domain/usecase/category/create/CreateUseCase";
import {
  DeleteCategoryUseCase,
  DeleteCategoryUseCaseImpl,
} from "../../domain/usecase/category/delete/DeleteUseCase";
import {
  GetCategoryUseCase,
  GetCategoryUseCaseImpl,
} from "../../domain/usecase/category/get/GetUseCase";
import {
  GetAllCategoriesUseCase,
  GetAllCategoriesUseCaseImpl,
} from "../../domain/usecase/category/getAll/GetAllUseCase";
import {
  UpdateCategoryUseCase,
  UpdateCategoryUseCaseImpl,
} from "../../domain/usecase/category/update/UpdateUseCase";
import {
  CreateQuestionUseCase,
  CreateQuestionUseCaseImpl,
} from "../../domain/usecase/question/create/CreateUseCase";
import {
  DeleteQuestionUseCase,
  DeleteQuestionUseCaseImpl,
} from "../../domain/usecase/question/delete/DeleteUseCase";
import {
  DeleteQuestionAttachmentUseCase,
  DeleteQuestionAttachmentUseCaseImpl,
} from "../../domain/usecase/question/deleteAttachment/UseCase";
import {
  FilterQuestionsByUseCase,
  FilterQuestionsByUseCaseImpl,
} from "../../domain/usecase/question/filter/FilterUseCase";
import {
  GetQuestionUseCase,
  GetQuestionUseCaseImpl,
} from "../../domain/usecase/question/get/GetUseCase";
import {
  GetAllQuestionsUseCase,
  GetAllQuestionsUseCaseImpl,
} from "../../domain/usecase/question/getAll/GetAllUseCase";
import {
  UpdateQuestionUseCase,
  UpdateQuestionUseCaseImpl,
} from "../../domain/usecase/question/update/UpdateUseCase";
import { GetAllStatsUseCase, GetAllStatsUseCaseImpl } from "../../domain/usecase/stats/getAll/GetAllStatsUseCase";
import {
  GetQuestionsAnswersStatsUseCase,
  GetQuestionsAnswersStatsUseCaseImpl,
} from "../../domain/usecase/stats/questionsAnswers/UseCase";
import {
  UploadFileUseCase,
  UploadFileUseCaseImpl,
} from "../../domain/usecase/uploadFile/UploadFileUseCase";
import { provideApiBuilder } from "./NetworkModule";

function provideNetworkApi(): NetworkApi {
  return new NetworkApiImpl(provideApiBuilder());
}

// auth
function provideAuthRepository(): AuthRepository {
  return new AuthRepositoryImpl(provideNetworkApi());
}
export function provideLoginUseCase(): LoginUseCase {
  return new LoginUseCaseImpl(provideAuthRepository());
}
// upload file
function provideUploadImageRepository(): UploadFileRepository {
  return new UploadFileRepositoryImpl(provideNetworkApi());
}
export function provideUploadFileUseCase(): UploadFileUseCase {
  return new UploadFileUseCaseImpl(provideUploadImageRepository());
}

// admin
function provideAdminRepository(): AdminRepository {
  return new AdminRepositoryImpl(provideNetworkApi());
}
export function provideGetAdminInfoUseCase(): GetAdminInfoUseCase {
  return new GetAdminInfoUseCaseImpl(provideAdminRepository());
}
export function provideUpdateAdminInfoUseCase(): UpdateAdminInfoUseCase {
  return new UpdateAdminInfoUseCaseImpl(provideAdminRepository());
}

// stats
function provideStatsRepository(): StatsRepository {
  return new StatsRepositoryImpl(provideNetworkApi());
}
export function provideGetAllStatsUseCase(): GetAllStatsUseCase {
  return new GetAllStatsUseCaseImpl(provideStatsRepository());
}
export function provideGetQuestionsAnswersStatsUseCase(): GetQuestionsAnswersStatsUseCase {
  return new GetQuestionsAnswersStatsUseCaseImpl(provideStatsRepository());
}

// category
function provideCategoryRepository(): CategoryRepository {
  return new CategoryRepositoryImpl(provideNetworkApi());
}
export function provideCreateCategoryUseCase(): CreateCategoryUseCase {
  return new CreateCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideGetCategoryUseCase(): GetCategoryUseCase {
  return new GetCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideUpdateCategoryUseCase(): UpdateCategoryUseCase {
  return new UpdateCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideDeleteCategoryUseCase(): DeleteCategoryUseCase {
  return new DeleteCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideGetAllCategoriesUseCase(): GetAllCategoriesUseCase {
  return new GetAllCategoriesUseCaseImpl(provideCategoryRepository());
}

// question
function provideQuestionRepository(): QuestionRepository {
  return new QuestionRepositoryImpl(provideNetworkApi());
}
export function provideCreateQuestionUseCase(): CreateQuestionUseCase {
  return new CreateQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideGetQuestionUseCase(): GetQuestionUseCase {
  return new GetQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideUpdateQuestionUseCase(): UpdateQuestionUseCase {
  return new UpdateQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideDeleteQuestionUseCase(): DeleteQuestionUseCase {
  return new DeleteQuestionUseCaseImpl(provideQuestionRepository());
}
export function provideGetAllQuestionsUseCase(): GetAllQuestionsUseCase {
  return new GetAllQuestionsUseCaseImpl(provideQuestionRepository());
}
export function provideFilterQuestionsByUseCase(): FilterQuestionsByUseCase {
  return new FilterQuestionsByUseCaseImpl(provideQuestionRepository());
}
export function provideDeleteQuestionAttachmentUseCase(): DeleteQuestionAttachmentUseCase {
  return new DeleteQuestionAttachmentUseCaseImpl(provideQuestionRepository());
}

// answer
function provideAnswerRepository(): AnswerRepository {
  return new AnswerRepositoryImpl(provideNetworkApi());
}
export function provideCreateAnswerUseCase(): CreateAnswerUseCase {
  return new CreateAnswerUseCaseImpl(provideAnswerRepository());
}
export function provideGetAnswerUseCase(): GetAnswerUseCase {
  return new GetAnswerUseCaseImpl(provideAnswerRepository());
}
export function provideGetAnswerByQuestionIdUseCase(): GetAnswerByQuestionIdUseCase {
  return new GetAnswerByQuestionIdUseCaseImpl(provideAnswerRepository());
}
export function provideGetAnswersByListOfQuestionsIdUseCase(): GetAnswersByListOfQuestionsIdUseCase {
  return new GetAnswersByListOfQuestionsIdUseCaseImpl(
    provideAnswerRepository(),
  );
}
export function provideUpdateAnswerUseCase(): UpdateAnswerUseCase {
  return new UpdateAnswerUseCaseImpl(provideAnswerRepository());
}
export function provideDeleteAnswerUseCase(): DeleteAnswerUseCase {
  return new DeleteAnswerUseCaseImpl(provideAnswerRepository());
}
export function provideGetAllAnswersUseCase(): GetAllAnswersUseCase {
  return new GetAllAnswersUseCaseImpl(provideAnswerRepository());
}
export function provideDeleteAnswerByQuestionIdUseCase(): DeleteAnswerByQuestionIdUseCase {
  return new DeleteAnswerByQuestionIdUseCaseImpl(provideAnswerRepository());
}
export function provideDeleteAnswerAttachmentUseCase(): DeleteAnswerAttachmentUseCase {
  return new DeleteAnswerAttachmentUseCaseImpl(provideAnswerRepository());
}
